import { defineComponent } from 'vue'
import { store } from '#stores/oneform'
import SignaturePadVue from '../SignaturePad/SignaturePad.vue'

export default defineComponent({
  components: {
    SignaturePad: SignaturePadVue
  },
  data() {
    const form = store.cancellationPolicyForm

    return {
      form
    }
  }
})
